// extracted by mini-css-extract-plugin
export var headerXL = "ClientCase-module--headerXL--1lxVA";
export var headerL = "ClientCase-module--headerL--2bv4e";
export var headerM = "ClientCase-module--headerM--1PFlA";
export var headerS = "ClientCase-module--headerS--1bUC2";
export var headerXS = "ClientCase-module--headerXS--1N3Jp";
export var blogHeaderXL = "ClientCase-module--blogHeaderXL--2JRv3";
export var blogHeaderL = "ClientCase-module--blogHeaderL--3oImQ";
export var blogHeaderM = "ClientCase-module--blogHeaderM--154XY";
export var blogHeaderS = "ClientCase-module--blogHeaderS--1r5qh";
export var blogHeaderXS = "ClientCase-module--blogHeaderXS--29dje";
export var headerPreamble = "ClientCase-module--headerPreamble--3HSuo";
export var preHeader = "ClientCase-module--preHeader--1ThRJ";
export var textNormal = "ClientCase-module--textNormal--2xYv3";
export var textSmall = "ClientCase-module--textSmall--2WTvT";
export var textSmallAlternate = "ClientCase-module--textSmallAlternate--QDbX4";
export var legend = "ClientCase-module--legend--1Hfzg";
export var caption = "ClientCase-module--caption--2AS4T";
export var gradientBackground = "ClientCase-module--gradientBackground--1H7AS";
export var ellipsis = "ClientCase-module--ellipsis--1ankp";
export var globalContainer = "ClientCase-module--globalContainer--2kmb9";
export var maxWidth = "ClientCase-module--maxWidth--1OpYo";
export var clipBottom = "ClientCase-module--clipBottom--ZN8eU";
export var clipTopBottom = "ClientCase-module--clipTopBottom--1PK3g";
export var clientCase = "ClientCase-module--clientCase--3AzgT";
export var textContainer = "ClientCase-module--textContainer--2XrwD";
export var name = "ClientCase-module--name--3ceVr";
export var title = "ClientCase-module--title--3pha0";
export var image = "ClientCase-module--image--1n8dT";
export var cmsImage = "ClientCase-module--cmsImage--1SnTL";
export var ch2 = "ClientCase-module--ch2--2dnd-";
export var ch2Container = "ClientCase-module--ch2-container--3LABU";